module.exports = __webpack_public_path__ + "img/tuikuanzhong@2x.314b7602.png";